module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "block-main-list",
    class: {
      hearings: _vm.showButtonsForHearing
    }
  }, [(_vm.showButtonsForMeeting) ? _c('li', {
    staticClass: "block-main-list-item"
  }, [_c('a', {
    staticClass: "icon icon-calendar icon-left",
    attrs: {
      "href": _vm.urlAgenda
    }
  }, [_vm._v(_vm._s(_vm.textAgenda))])]) : _vm._e(), _vm._v(" "), (_vm.showButtonsForMeeting) ? _c('li', {
    staticClass: "block-main-list-item"
  }, [_c('a', {
    staticClass: "icon icon-speech icon-left",
    attrs: {
      "href": _vm.urlSpeakerList
    }
  }, [_vm._v(_vm._s(_vm.textSpeakerList))])]) : _vm._e(), _vm._v(" "), (_vm.showButtonsForHearing) ? _c('li', {
    staticClass: "block-main-list-item"
  }, [_c('a', {
    staticClass: "icon icon-calendar icon-left",
    attrs: {
      "href": _vm.urlHearingAgenda
    }
  }, [_vm._v(_vm._s(_vm.textHearingAgenda))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "block-main-list-item"
  }, [_c('a', {
    staticClass: "icon icon-video icon-left",
    attrs: {
      "href": _vm.urlVideoArchive
    }
  }, [_vm._v(_vm._s(_vm.textVideoArchive))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ad05396"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top/TopTextBoxBottomButtons.vue
// module id = 95
// module chunks = 1